import { useDispatch } from 'react-redux'
import { Redirect, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Loader } from '@carsys/ui/src/Loader'
import { IBankHoliday } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'
import { useQuery } from '@cbgms/base/http/use-query'

import HolidayForm from './HolidayForm'
import { createBankHoliday } from '../state/actions'
import { preloadDataForNewHoliday } from '../utils/data-helpers'

const NewHoliday = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const history = useHistory()
  const preloadData = useQuery(['NewHoliday', 'preloadDataForNewHoliday'], async () => {
    return preloadDataForNewHoliday(dispatch)
  })

  const onSubmit = async (values: IBankHoliday) => {
    try {
      const val = { ...values, UUID: undefined }
      const {
        Data: { UUID }
      } = await dispatch(createBankHoliday(val))
      return { ...values, UUID }
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async (v: IBankHoliday) => {
    notifier.success(t('bank_holidays.successfully_created'))
    history.push(`/bank-holidays/edit/${v.UUID}`)
  }

  if (preloadData.isLoading || !preloadData.data) {
    return <Loader loading />
  }

  if (preloadData.isError) {
    notifier.error(t('global.something_went_wrong'))

    return <Redirect to='/bank-holidays' />
  }

  return (
    <HolidayForm
      regionTags={preloadData.data.regionTags}
      headerText='bank_holidays.new_holiday'
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      form='new_bank_holiday'
      initialValues={preloadData.data.initialValues}
    />
  )
}

export default NewHoliday
